import { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './App.css';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NavBarr from './Components/NavBar/NavBarr';
import Home from './Pages/Home';
import Footer from './Components/Footer/Footer';
import Bareq from './Pages/Bareq';
import ArabicForLife from './Pages/ArabicForLife';
import KalemonK12 from './Pages/KalemonK12';
import ContactUs from './Components/contactUs/ContactUs';
import Teachers from './Components/Teachers/Teachers';
import HowYouLearn from './Components/howYouLearn/WhyKalemon';
import ArabicCalligraphy from './Pages/ArabicCalligraphy';
import KalemonLevels from './Pages/KalemonLevels';
import ArabicSpecialized from './Pages/ArabicSpecialized';
import AllPrograms from './Pages/AllPrograms';
import ConversationProgram from './Pages/ConversationProgram';
import HowWeLearn from './Pages/HowWeLearn';
import ScrollToTop from './Components/scrollToTop/ScrollToTop';
import OurTeachers from './Pages/OurTeachers';
import WhyKalemon from './Components/howYouLearn/WhyKalemon';

function App() {

  const [collapsed, setCollapsed] = useState(false);

  const [expanded, setExpanded] = useState(false);


  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setCollapsed(true);
      } else {
        setCollapsed(false);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  useEffect(() => {
    document.body.dir = localStorage.getItem("i18nextLng") === "ar" ? "rtl" : "ltr";
  }, []);


  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />

        <NavBarr />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/bareq" element={<Bareq />} />
          <Route path="/arabic-for-life" element={<ArabicForLife />} />
          <Route path="/kalemon-k12" element={<KalemonK12 />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/teachers" element={<Teachers />} />
          <Route path="/why-kalemon" element={<WhyKalemon />} />
          <Route path="/kalemon-levels" element={<KalemonLevels />} />
          <Route path="/arabic-calligraphy" element={<ArabicCalligraphy />} />
          <Route path="/arabic-specialized" element={<ArabicSpecialized />} />
          <Route path="/all-programs" element={<AllPrograms />} />
          <Route path="/conversation-program" element={<ConversationProgram />} />
          <Route path="/how-we-learn" element={<HowWeLearn />} />
          <Route path="/our-teachers" element={<OurTeachers />} />

        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
